import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import ChiSiamo from './pages/ChiSiamo';
import Home from './pages/Home';


const loading = (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)
  
/*const Page404 = React.lazy(() => import('./pages/errorPages/Page404'))
const Page500 = React.lazy(() => import('./pages/errorPages/Page500'))*/
const Container = React.lazy(() => import('./pages/Container'))

function App() {
  return (
    <HashRouter>
        <Suspense fallback={loading}>
            <Home />
        </Suspense>
    </HashRouter>
  );
}

export default App;
